import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";

import NavData from "../../data/navigation";

import StateContext from "../../contexts/StateContext";
import DispatchContext from "../../contexts/DispatchContext";

import LogoKC21 from "./LogoKC21";

function Sidebar(props) {
  const appState = useContext(StateContext);
  const appDispatch = useContext(DispatchContext);

  const [burgerOpen, setBurger] = useState(false);

  function onButtonClick(action) {
    switch (action) {
      case "logout":
        appDispatch({ type: "logout" });
        break;
      default:
        return;
    }
  }

  const isDisabled = item => {
    return Boolean(item.conditional) ? Boolean(item.conditional(appState).disabled) : false;
  };
  const isShown = item => {
    return !Boolean(item.conditional) ? true : Boolean(item.conditional(appState).show);
  };

  const getLabel = strg => {
    if (strg !== "Testgruppen" || appState.user.navType !== "testender-mandant") return strg;
    return "Eigene " + strg;
  };

  const createNav = () => {
    let navpoints = NavData.main.entries.map((entry, idx) => {
      if (isShown(entry)) {
        switch (entry.type) {
          case "menu":
            let subentries = entry.submenu.map((sub, sidx) => {
              if (isShown(sub)) {
                let css = isDisabled(sub) ? "disabled" : null;
                return (
                  <li key={`nav-main-${idx}-${sidx}`}>
                    <Link to={sub.href} className={css}>
                      {sub.label}
                    </Link>
                  </li>
                );
              } else {
                return null;
              }
            });
            return (
              <li key={`nav-main-${idx}`}>
                <div className="submenu-title">
                  {entry.icon && <span className={`fas ${entry.icon}`}></span>}
                  {getLabel(entry.label)}
                </div>
                <ul>{subentries}</ul>
              </li>
            );
          case "link":
            let css = isDisabled(entry) ? "disabled" : null;
            return (
              <li key={`nav-main-${idx}`}>
                <Link to={entry.href} className={css}>
                  {entry.icon && <span className={`fas ${entry.icon}`}></span>}
                  {entry.label}
                </Link>
              </li>
            );
          case "button":
            return (
              <li key={`nav-main-${idx}`}>
                <button
                  type="button"
                  className="linklike"
                  onClick={() => {
                    onButtonClick(entry.action);
                  }}
                  disabled={isDisabled(entry)}>
                  {entry.icon && <span className={`fas ${entry.icon}`}></span>}
                  {entry.label}
                </button>
              </li>
            );
          default:
            return null;
        }
      } else {
        return null;
      }
    });
    return navpoints;
  };

  const createFooter = () => {
    if (!NavData.footer.entries || !NavData.footer.entries.length) return null;
    let footerArray = (!appState.loggedIn ? [{ type: "link", href: "/", label: "Login" }] : []).concat(NavData.footer.entries);
    let entries = footerArray.map((entry, idx) => {
      let props = {
        className: "smallprint",
        target: entry.target ? entry.target : null,
        to: entry.type === "link" ? entry.href : null,
        href: entry.type === "external" ? entry.href : null
      };
      return (
        <li key={`footer-nav-${idx}`}>
          {entry.type === "link" && <Link {...props}>{entry.label}</Link>}
          {entry.type === "external" && <a {...props}>{entry.label}</a>}
        </li>
      );
    });
    return <ul className="links">{entries}</ul>;
  };

  const onHamburgerClick = e => {
    e.preventDefault();
    setBurger(!burgerOpen);
  };

  let classes = ["sidebar"];
  if (appState.loggedIn) classes.push("loggedIn");
  if (burgerOpen) classes.push("is-active");

  return (
    <aside className={classes.join(" ")}>
      <div className="top">
        <Link to="/">
          <LogoKC21 />
        </Link>
        <button className={`hamburger hamburger--elastic${burgerOpen ? " is-active" : ""}`} type="button" onClick={onHamburgerClick}>
          <span className="hamburger-box">
            <span className="hamburger-inner"></span>
          </span>
        </button>
      </div>
      {appState.loggedIn && appState.user.navType && (
        <>
          <nav id="main-nav" className="menu">
            <ul className="menu-list">{createNav()}</ul>
          </nav>
          {process && process.env && process.env.NODE_ENV === "development" && (
            <code className="debug">
              user-type: {appState.user.type}
              <br />
              nav-type: {appState.user.navType}
            </code>
          )}
        </>
      )}
      <footer className="side-footer">{createFooter()}</footer>
    </aside>
  );
}
export default Sidebar;
